<template>
  <div>
    <v-card :loading="loading" flat>
      <div class="d-flex flex-column flex-sm-row align-sm-end">
        <div class="ma-2">
          <div class="text-h5">Drug Companies</div>
          <div class="subtitle-1">Labelers and re-labelers.</div>
        </div>
        <div class="mx-sm-4 px-4">
          <v-text-field
            placeholder="Filter Companies"
            v-model="filterInput"
            dense
            clearable
            class="inputWidth"
          ></v-text-field>
        </div>
      </div>
      <v-divider></v-divider>
      <div v-if="filteredCompanies" class="d-flex flex-wrap ma-4">
        <v-card
          v-for="company in filteredCompanies"
          :key="company.id"
          class="ma-2 align-center pointer"
          width="300"
          height="60"
          color="#f6f6f6"
          flat
          @click="
            companyDetailsRouter(company.labeler_ndc, company.labeler_name)
          "
        >
          <div class="pa-2 text-center">
            <div class="subtitle-2">
              {{ company.alt_name ? company.alt_name : company.labeler_name }}
            </div>

            <div class="caption" v-if="company.subtitle">
              {{ company.subtitle }}
            </div>
          </div>
        </v-card>
      </div>
      <!-- {{ companies }} -->
    </v-card>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
import Slugify from "slugify";

// import Name from "../dir/file";

export default {
  name: "MedCompanies",
  props: {},
  data: function () {
    return {
      companies: [],
      loading: false,
      filterInput: "",
    };
  },
  methods: {
    slugText(name) {
      return Slugify(name.toLowerCase());
    },
    // getCompanyMeds(id, name) {
    //   this.$router.push({ path: "/companies/" + id });
    // },
    companyDetailsRouter(id, name) {
      let url = `/meds/companies/${id}/`;
      url += this.slugText(name);
      this.$router.push({ path: url });
    },
  },
  computed: {
    filteredCompanies: function () {
      //if (!Array,isArray( this.companies) ) return null;
      if (!this.filterInput || this.filterInput == "") return this.companies;
      const filter = this.filterInput.trim().toLowerCase();

      let filtered = this.companies.filter((item) => {
        let match = item.labeler_name.toLowerCase().includes(filter);
        if (item.alt_name) {
          match = match || item.alt_name.toLowerCase().includes(filter);
        }
        if (item.subtitle) {
          match = match || item.subtitle.toLowerCase().includes(filter);
        }
        if (item.labeler_ndc) {
          match = match || item.labeler_ndc.toLowerCase().includes(filter);
        }
        return match;
      });
      return filtered;
    },
  },
  mounted: function () {
    ApiServices.genericApiCall("/meds/companies")
      .then((response) => {
        this.companies = response.data.companies;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
  },
  metaInfo() {
    return {
      title: "EyeDock/Meds | Browse Companies",
    };
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
.inputWidth {
  width: 200px;
}
</style>
